export default __webpack_public_path__ + "static/media/logo-mini.840e5559.svg";